import { render, staticRenderFns } from "./WeldingRingSet.vue?vue&type=template&id=b1837652&scoped=true&lang=pug"
import script from "./WeldingRingSet.vue?vue&type=script&lang=js"
export * from "./WeldingRingSet.vue?vue&type=script&lang=js"
import style0 from "./WeldingRingSet.vue?vue&type=style&index=0&id=b1837652&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1837652",
  null
  
)

export default component.exports